import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    TextField,
    Button,
    Typography,
    Box,
    Grid,
    Paper
} from '@mui/material';
import img from '../assets/qural1.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { makeApiRequest } from '../utils/api';
import bg from '../asserts/Background.png';

export const VerifyLogin = () => {
    const [registrationNumber, setRegistrationNumber] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setRegistrationNumber(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleVerify();
        }
    };

    const handleVerify = async () => {
        try {
            const response = await makeApiRequest('post', '/api/certificate/verify/login', {
                userid: registrationNumber
            });

            if (response.status === "success") {
                navigate('/certificate/validation', { state: { data: response.data } });
            } else {
                toast.error('Invalid response received');
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            toast.error('The Certificate is not yet generated for the student');
        }
    };


    return (
        <Box>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <Grid container sx={{ backgroundColor: '#ffffff', padding: 2, alignItems: 'center',display:'flex' ,justifyContent:'space-between'}}>
                <Grid item xs={12} sm={4}>
                    <Box
                        component="img"
                        src={img}
                        alt="Logo"
                        sx={{ width: '100%', maxHeight: 100, objectFit: 'contain' }}
                    />
                </Grid>
                <Grid item xs={12} sm={8} sx={{display:'flex',ustifyContent:'flex-end'}}>
                    <Typography variant="h4" fontWeight="bold">
                        Verify Student's <span style={{ color: 'blue' }}>Certificate</span>
                    </Typography>
                </Grid>
            </Grid>

            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{
                    backgroundImage: `url(${bg})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '90vh',
                    py: 4,
                }}
            >
                <Grid item xs={11} sm={8} md={6} lg={4}>
                    <Paper
                        elevation={6}
                        sx={{
                            borderRadius: 3,
                            px: { xs: 3, sm: 4 },
                            py: { xs: 4, sm: 5 },
                            backgroundColor: '#eef2f8',
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            variant="h5"
                            gutterBottom
                            sx={{
                                fontWeight: 500,
                                fontFamily: 'Georgia, serif',
                                mb: 3,
                            }}
                        >
                            Enter Registration Number
                        </Typography>

                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter here"
                            value={registrationNumber}
                            onChange={handleChange}
                            onKeyPress={handleKeyPress}
                            InputProps={{
                                style: {
                                    backgroundColor: 'white',
                                    fontSize: '16px',
                                },
                            }}
                        />

                        <Button
                            variant="contained"
                            onClick={handleVerify}
                            fullWidth
                            sx={{
                                mt: 4,
                                py: 1.5,
                                borderRadius: 5,
                                backgroundColor: '#00d79f',
                                fontWeight: 'bold',
                                fontSize: '16px',
                                '&:hover': {
                                    backgroundColor: '#00c78c',
                                },
                            }}
                        >
                            Verify
                        </Button>

                        {errorMessage && (
                            <Typography
                                variant="body2"
                                color="error"
                                sx={{ mt: 2 }}
                            >
                                {errorMessage}
                            </Typography>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};
